export const ADDRESS_CLASSIFICATION = {
  RESIDENTIAL: 'residential',
  COMMERCIAL: 'commercial',
  MILITARY: 'military',
  UNKNOWN: 'unknown',
};

export const ADDRESS_STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  APT_NEEDED: 'apt_needed',
  FORCED: 'forced',
};

export const ADDRESS_FIELDS = {
  BASE_STREET: 'base_street',
  STREET: 'street',
  APT: 'apt',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  OWNERSHIP: 'ownership',
};

export const ADDRESS_ERRORS = {
  INVALID: ADDRESS_STATUS.INVALID,
  APT_NEEDED: ADDRESS_STATUS.APT_NEEDED,
  APT_NOT_FOUND: 'apt_not_found',
  COMMERCIAL_FROM: 'commercial_from',
  COMMERCIAL_TO: 'commercial_to',
  MILITARY: 'military',
  DUPLICATE: 'duplicate',
  REQUIRED: 'required',
};

export const REQUIRED_FIELDS = [
  ADDRESS_FIELDS.BASE_STREET,
  ADDRESS_FIELDS.CITY,
  ADDRESS_FIELDS.STATE,
  ADDRESS_FIELDS.ZIP,
];
